import { render, staticRenderFns } from "./radio-item.vue?vue&type=template&id=63f5c620&scoped=true"
import script from "./radio-item.vue?vue&type=script&lang=js"
export * from "./radio-item.vue?vue&type=script&lang=js"
import style0 from "./radio-item.vue?vue&type=style&index=0&id=63f5c620&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5c620",
  null
  
)

export default component.exports